import React from "react";

import GuideCountry from "./component/GuideCountry";
import GuideType from "./component/GuideType";

const GuidePrefab = (props) => {
  const { slugs } = props;
  if (slugs.length === 1) {
    return (
      <GuideCountry
        {...props}
        continentSelected={null}
        countrySelected={slugs[0]}
      />
    );
  } else if (slugs.length === 2) {
    return (
      <GuideType
        {...props}
        continentSelected={null}
        countrySelected={slugs[0]}
        stateSelected={
          slugs[1].includes("-state") &&
          !slugs[1].includes("prefab-homes-manufacturers")
            ? slugs[1]
            : null
        }
        citySelected={null}
        typeSelected={
          slugs[1].includes("prefab-homes-manufacturers") &&
          !slugs[1].includes("-state")
            ? slugs[1]
            : null
        }
      />
    );
  }
};

export default GuidePrefab;
